import { oz } from '@weft/utils';

export const SlackUserPayloadSchema = oz.object({
  id: oz.string(),
  username: oz.string(),
  name: oz.string().optional(),
  team_id: oz.string().optional(),
}).openapi('SlackUser');
  
export type SlackUserPayload = oz.infer<typeof SlackUserPayloadSchema>;